import styled from 'styled-components';
import { Input, InputProps } from 'formik-antd';

export default styled(Input)<InputProps>`
  &::placeholder {
    color: var(--placeholder-color);
  }
`;
